<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="activityTitle">
                <span slot="label" ><a-tooltip>{{ $t('活动标题') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.activityTitle" :maxLength="32" :placeholder="$t('请输入')+'活动标题'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item prop="addressDetail">
                  <span slot="label" ><a-tooltip>{{ $t('详细地址') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.addressDetail" :maxLength="32" :placeholder="$t('请输入')+'详细地址'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="auditReason">
                  <span slot="label" ><a-tooltip>{{ $t('审核原因') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.auditReason" :maxLength="32" :placeholder="$t('请输入')+'审核原因'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createBeginTime"
                    :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createEndTime"
                    :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['community:communitygroupactivity:add']">
          <a-icon type="plus" />{{ $t('新增') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['community:communitygroupactivity:edit']">
          <a-icon type="edit" />{{ $t('修改') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['community:communitygroupactivity:remove']">
          <a-icon type="delete" />{{ $t('删除') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['community:communitygroupactivity:export']">
          <a-icon type="download" />{{ $t('导出') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 3300 }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="activityCover" slot-scope="text, record">
          <div>
            <img v-if="record.activityCover" :src="record.activityCover" style="width:60px;height:60px;border-radius:4px;object-fit:cover;" alt="none"/>
          </div>
        </span>
        <span slot="signupStartTime" slot-scope="text, record">
          {{ parseTime(record.signupStartTime) }}
        </span>
        <span slot="signupEndTime" slot-scope="text, record">
          {{ parseTime(record.signupEndTime) }}
        </span>
        <span slot="activityStartTime" slot-scope="text, record">
          {{ parseTime(record.activityStartTime) }}
        </span>
        <span slot="activityEndTime" slot-scope="text, record">
          {{ parseTime(record.activityEndTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="activityStatus" slot-scope="text, record">
          <span v-if="record.activityStatus == 1010">{{ $t('报名中') }}</span>
          <span v-else-if="record.activityStatus == 1020">{{ $t('进行中') }}</span>
          <span v-else-if="record.activityStatus == 1030">{{ $t('已结束') }}</span>
          <span v-else-if="record.activityStatus == 1040">{{ $t('已取消') }}</span>
          <span v-else-if="record.activityStatus == 1050">{{ $t('已下架') }}</span>
          <span v-else>{{ record.activityStatus }}</span>
        </span>
        <span slot="activityCategory" slot-scope="text, record">
          <custom-dict-tag :options="customDict.ActivityCategoryEnum" :value="record.activityCategory"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['community:communitygroupactivity:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['community:communitygroupactivity:edit']">
            <a-icon type="edit" />{{ $t('修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['community:communitygroupactivity:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['community:communitygroupactivity:remove']">
            <a-icon type="delete" />{{ $t('删除') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCommunityGroupActivity, listCommunityGroupActivity, delCommunityGroupActivity } from '@/api/community/communityGroup/communityGroupActivity'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CommunityGroupActivity',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        activityTitle: undefined,
        activityCover: undefined,
        activityContent: undefined,
        signupStartTime: undefined,
        signupEndTime: undefined,
        activityStartTime: undefined,
        activityEndTime: undefined,
        addressDetail: undefined,
        auditReason: undefined,
        pageNum: 1,
        pageSize: 10,
        activityCategory: undefined
      },
      columns: [
        {
          title: this.$t('编号'),
          dataIndex: 'id',
          width: 80,
          align: 'center'
        },        {
          title: this.$t('活动标题'),
          dataIndex: 'activityTitle',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('活动封面URL'),
          dataIndex: 'activityCover',
          width: 200,
          align: 'center',
          scopedSlots: { customRender: 'activityCover' },
        },
        {
          title: this.$t('活动详情'),
          dataIndex: 'activityContent',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('活动状态'),
          dataIndex: 'activityStatus',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'activityStatus' }
        },
        {
          title: this.$t('活动分类'),
          dataIndex: 'activityCategory',
          width: 130,
          align: 'center',
          scopedSlots: { customRender: 'activityCategory' }
        },
        {
          title: this.$t('报名开始时间'),
          dataIndex: 'signupStartTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'signupStartTime' }
        },
        {
          title: this.$t('报名结束时间'),
          dataIndex: 'signupEndTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'signupEndTime' }
        },
        {
          title: this.$t('活动开始时间'),
          dataIndex: 'activityStartTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'activityStartTime' }
        },
        {
          title: this.$t('活动结束时间'),
          dataIndex: 'activityEndTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'activityEndTime' }
       },
       {
         title: this.$t('详细地址'),
          dataIndex: 'addressDetail',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('定位经度'),
          dataIndex: 'addressLongitude',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('定位纬度'),
          dataIndex: 'addressLatitude',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('审核原因'),
          dataIndex: 'auditReason',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          fixed: 'right',
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询社区活动列表 */
    getList () {
      this.loading = true
     pageCommunityGroupActivity(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
      }).catch(() => {
        this.list = []
        this.total = 0
      }).finally(() => {
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        activityTitle: undefined,
        activityCover: undefined,
        activityContent: undefined,
        signupStartTime: undefined,
        signupEndTime: undefined,
        activityStartTime: undefined,
        activityEndTime: undefined,
        addressDetail: undefined,
        auditReason: undefined,
        pageNum: 1,
        pageSize: 10,
        activityCategory: undefined
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      const reqData = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delCommunityGroupActivity(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message, 3)
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/community/community/group/activity/export',
            that.queryParam
          , `社区活动_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
